import { IResponse } from '@type/response';
import { qdfoodApi } from './constant';
import { ICategory } from '@type/category';

export const CATEGORY_API = {
  urlGetCategory: `/category/list/web-user`,
  urlGetAllCategory: `/category/web-user`,
};

export default class categoryApi {
  static getCategory() {
    return qdfoodApi().get<ICategory[]>(CATEGORY_API.urlGetCategory, {
      params: {
        isDeleted: false,
        sort: 'createdAt',
        order: 'desc',
      },
    });
  }
  static getAllCategory() {
    return qdfoodApi().get<IResponse<ICategory>>(CATEGORY_API.urlGetAllCategory, {
      params: {
        isDeleted: false,
        sort: 'createdAt',
        order: 'desc',
      },
    });
  }
}
